import { AdClickTrackingHandler } from "./ad-click-tracking-handler";
import { AdClickTrackingListener } from "./ad-click-tracking-listener";

export class AdClickTrackingSetup {
    public static init(): void {
        if (document.body.dataset.adClickTrackingBound === "1") {
            return;
        }

        document.body.dataset.adClickTrackingBound = "1";

        const handler = new AdClickTrackingHandler();
        const listener = new AdClickTrackingListener(handler);
        listener.register();
    }
}
